import {
  companySizesSelectOptions,
  countriesSelectInboundOptions,
  industriesSelectInboundOptions,
  jobLevelsSelectInboundOptions,
  jobResponsibilitiesSelectInboundOptions,
  salutationsSelectInboundOptions,
  typesOfBusinessSelectInboundOptions,
} from '@constants/mappings';
import {
  INBOUND_ACTIONS,
  InboundAction,
} from '@hubs101/booking-api-skd-client/lib/types';
import {
  emailValidationRule,
  phoneNumberValidationRule,
  requiredValidationRule,
} from '@utils/form';

export const buttonTypes = [
  'agenda-download',
  'attendeelist-download',
  'partner-prospectus-download',
  'apply-as-speaker',
  'apply-as-partner',
  'save-the-date',
  'book-now',
];

export const orderedFields = [
  'salutation',
  'first_name',
  'last_name',
  'email',
  'contact_mobile',
  'contact_phone',
  'job_title',
  'company_name',
  'job_responsibility',
  'job_level',
  'company_size',
  'company_type_of_business',
  'address_street',
  'address_city',
  'address_country',
  'address_state',
  'address_postal_code',
  'company_industry',
  'contact_linkedin',
  'contact_twitter',
  'contact_xing',
  'contact_instagram',
  'contact_facebook',
  'contact_website1',
  'company_linkedin',
  'company_twitter',
  'company_xing',
  'company_instagram',
  'company_facebook',
  'company_website1',
];

export const orderedLandingRegistrationFields = [
  'salutation',
  'first_name',
  'last_name',
  'job_title',
  'job_responsibility',
  'job_level',
  'company_name',
  'email',
  'contact_mobile',
  'contact_phone',
  'company_size',
  'company_type_of_business',
  'address_street',
  'address_city',
  'address_country',
  'address_state',
  'address_postal_code',
  'company_industry',
  'contact_linkedin',
  'contact_twitter',
  'contact_xing',
  'contact_instagram',
  'contact_facebook',
  'contact_website1',
  'company_linkedin',
  'company_twitter',
  'company_xing',
  'company_instagram',
  'company_facebook',
  'company_website1',
];

export const orderedRegistrationFields = [
  'salutation',
  'first_name',
  'last_name',
  'email',
  'contact_mobile',
  'contact_phone',
  'job_title',
  'job_responsibility',
  'job_level',
  'company_name',
  'company_size',
  'company_type_of_business',
  'address_street',
  'address_city',
  'address_country',
  'address_state',
  'address_postal_code',
  'company_industry',
  'contact_linkedin',
  'contact_twitter',
  'contact_xing',
  'contact_instagram',
  'contact_facebook',
  'contact_website1',
  'company_linkedin',
  'company_twitter',
  'company_xing',
  'company_instagram',
  'company_facebook',
  'company_website1',
];

export type SelectOptionsType<T = string> = Array<{
  readonly value: T;
  readonly label: string;
}>;

type DesignTypeFieldsType = Array<{
  readonly id: string;
  readonly desktop: number;
  readonly mobile: number;
  readonly type: string;
  readonly options?: SelectOptionsType;
}>;

export const designTypeFields: DesignTypeFieldsType = [
  {
    id: 'salutation',
    desktop: 2.8,
    mobile: 12,
    type: 'input-select',
    options: salutationsSelectInboundOptions.filter(e => e.value !== 'divers'),
  },
  {
    id: 'job_responsibility',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: jobResponsibilitiesSelectInboundOptions,
  },
  {
    id: 'job_level',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: jobLevelsSelectInboundOptions,
  },
  {
    id: 'company_size',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: companySizesSelectOptions,
  },
  {
    id: 'company_type_of_business',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: typesOfBusinessSelectInboundOptions,
  },
  {
    id: 'address_country',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: countriesSelectInboundOptions,
  },
  {
    id: 'company_industry',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: industriesSelectInboundOptions,
  },
  {
    id: 'contact_mobile',
    desktop: 5.76,
    mobile: 12,
    type: 'phone-number',
  },
  {
    id: 'contact_phone',
    desktop: 5.76,
    mobile: 12,
    type: 'phone-number',
  },
  { id: 'first_name', desktop: 4.12, mobile: 12, type: 'input-text' },
  { id: 'last_name', desktop: 4.12, mobile: 12, type: 'input-text' },
  { id: 'email', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'job_title', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_name', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'address_street', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_city', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'address_country', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'address_state', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'address_postal_code', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_industry', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_linkedin', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_twitter', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_xing', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_instagram', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_facebook', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_website1', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_linkedin', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_twitter', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_xing', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_instagram', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_facebook', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_website1', desktop: 5.76, mobile: 12, type: 'input-text' },
];

export const designTypeFieldsLandingRegistration: DesignTypeFieldsType = [
  {
    id: 'salutation',
    desktop: 2.8,
    mobile: 12,
    type: 'input-select',
    options: salutationsSelectInboundOptions.filter(e => e.value !== 'divers'),
  },
  {
    id: 'job_responsibility',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: jobResponsibilitiesSelectInboundOptions,
  },
  {
    id: 'job_level',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: jobLevelsSelectInboundOptions,
  },
  {
    id: 'company_size',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: companySizesSelectOptions,
  },
  {
    id: 'company_type_of_business',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: typesOfBusinessSelectInboundOptions,
  },
  {
    id: 'address_country',
    desktop: 12,
    mobile: 12,
    type: 'input-select',
    options: countriesSelectInboundOptions,
  },
  {
    id: 'company_industry',
    desktop: 5.76,
    mobile: 12,
    type: 'input-select',
    options: industriesSelectInboundOptions,
  },
  {
    id: 'contact_mobile',
    desktop: 5.76,
    mobile: 12,
    type: 'phone-number',
  },
  {
    id: 'contact_phone',
    desktop: 5.76,
    mobile: 12,
    type: 'phone-number',
  },
  { id: 'first_name', desktop: 4.12, mobile: 12, type: 'input-text' },
  { id: 'last_name', desktop: 4.12, mobile: 12, type: 'input-text' },
  { id: 'email', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'job_title', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_name', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'address_street', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_city', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'address_country', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_state', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'address_postal_code', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_industry', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_linkedin', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_twitter', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_xing', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_instagram', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'contact_facebook', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_website1', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_linkedin', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_twitter', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_xing', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_instagram', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_facebook', desktop: 5.76, mobile: 12, type: 'input-text' },
  { id: 'company_website1', desktop: 5.76, mobile: 12, type: 'input-text' },
];

export const designTypeFullWidthFields: DesignTypeFieldsType = [
  {
    id: 'salutation',
    desktop: 7.76,
    mobile: 12,
    type: 'input-select',
    options: salutationsSelectInboundOptions.filter(e => e.value !== 'divers'),
  },
  {
    id: 'job_responsibility',
    desktop: 12,
    mobile: 12,
    type: 'input-select',
    options: jobResponsibilitiesSelectInboundOptions,
  },
  {
    id: 'job_level',
    desktop: 12,
    mobile: 12,
    type: 'input-select',
    options: jobLevelsSelectInboundOptions,
  },
  {
    id: 'company_size',
    desktop: 12,
    mobile: 12,
    type: 'input-select',
    options: companySizesSelectOptions,
  },
  {
    id: 'company_type_of_business',
    desktop: 12,
    mobile: 12,
    type: 'input-select',
    options: typesOfBusinessSelectInboundOptions,
  },
  {
    id: 'address_country',
    desktop: 12,
    mobile: 12,
    type: 'input-select',
    options: countriesSelectInboundOptions,
  },
  {
    id: 'company_industry',
    desktop: 12,
    mobile: 12,
    type: 'input-select',
    options: industriesSelectInboundOptions,
  },
  {
    id: 'contact_mobile',
    desktop: 12,
    mobile: 12,
    type: 'phone-number',
  },
  {
    id: 'contact_phone',
    desktop: 12,
    mobile: 12,
    type: 'phone-number',
  },
  { id: 'first_name', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'last_name', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'email', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'job_title', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_name', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_street', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_city', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_country', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_state', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'address_postal_code', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_industry', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_linkedin', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_twitter', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_xing', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_instagram', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_facebook', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'contact_website1', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_linkedin', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_twitter', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_xing', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_instagram', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_facebook', desktop: 12, mobile: 12, type: 'input-text' },
  { id: 'company_website1', desktop: 12, mobile: 12, type: 'input-text' },
];

export type InputFieldsType = Array<{
  readonly id: string;
  readonly desktop: number;
  readonly mobile: number;
  readonly required: boolean;
  readonly visible: boolean;
  readonly type: string;
  readonly options?: SelectOptionsType;
}>;

type ValidationRule = Record<string, unknown>;

interface Item {
  required?: boolean;
  type?: string;
  id?: string;
}

type RuleFunction = (rules: ValidationRule, item: Item) => ValidationRule;

const applyRequiredRule: RuleFunction = (rules, item) =>
  item.required ? { ...rules, ...requiredValidationRule } : rules;

const applyPhoneNumberRule: RuleFunction = (rules, item) =>
  item.type === 'phone-number'
    ? { ...rules, ...phoneNumberValidationRule }
    : rules;

const applyEmailRule: RuleFunction = (rules, item) =>
  item.id === 'email' ? { ...rules, ...emailValidationRule } : rules;

export const getValidationRules = (item: Item): ValidationRule =>
  [applyRequiredRule, applyPhoneNumberRule, applyEmailRule].reduce(
    (rules, ruleFunction) => ruleFunction(rules, item),
    {}
  );

export const mappingInbound: Record<string, Record<string, string>> = {
  salutation: {
    mr: 'Mr.',
    mrs: 'Mrs.',
  },
  job_responsibility: {
    influencer: 'Influencer',
    decision_maker: 'DecisionMaker',
  },
  job_level: {
    owner_boardmember_partner: 'Owner_Board__Member_Partner',
    ceo_cxo_md: 'CXO_Partner_Owner_MD',
    vp_svp_globalhead: 'VP_SVP',
    director_headof_leader: 'Director_Head_Leader',
    seniormanager_manager_projectmanager_teamleader:
      'SeniorManager_Manager_ProjectManager',
    employee: 'Employee:',
    assistant: 'Assistant',
  },
  company_type_of_business: {
    enduser: 'EndUser',
    vendor: 'Vendor',
  },
  company_industry: {
    academia: 'Academia',
    aerospacedefense: 'AerospaceDefense',
    apparel: 'Apparel',
    associations: 'Associations',
    automotive: 'AutomotiveTier1',
    banking: 'Banking',
    biotechnology: 'Biotechnology',
    chemicals: 'Chemicals',
    communications: 'Communications',
    construction: 'Construction',
    consumergoods: 'ConsumerGoods',
    consulting: 'Consulting',
    ecommerce: 'eCommerce',
    education: 'Education',
    electronics: 'Electronics',
    energy: 'Energy',
    engineering: 'Engineering',
    entertainment: 'Entertainment',
    environmental: 'Environmental',
    finance: 'Finance',
    foodbeverages: 'FoodBeverage',
    government: 'Government',
    hardwareprovider: 'HardwareProvider',
    healthcare: 'Healthcare',
    hospitality: 'Hospitality',
    insurance: 'Insurance',
    investor: 'Investor',
    legal: 'Legal',
    logistics: 'Logistics',
    machinery: 'Machinery',
    manufacturing: 'Manufacturing',
    media: 'Media',
    ngo: 'NGO',
    oilgas: 'OilGas',
    pharmaceuticals: 'Pharmaceuticals',
    retail: 'Retail',
    shipping: 'Shipping',
    softwareprovider: 'SoftwareProvider',
    startup: 'Startup',
    technology: 'Technology',
    technologyprovider: 'TechnologyProvider',
    telecommunications: 'Telecommunications',
    tier: 'Tier1',
    tourism: 'Tier1',
    transportation: 'Transportation',
    utilities: 'Utilities',
    other: 'Other',
  },
  address_country: {
    afghanistan: 'AFGHANISTAN',
    albania: 'ALBANIA',
    algeria: 'ALGERIA',
    american_samoa: 'AMERICAN SAMOA',
    andorra: 'ANDORRA',
    angolla: 'ANGOLA',
    anguilla: 'ANGUILLA',
    antarctica: 'ANTARCTICA',
    antigua: 'ANTIGUA',
    argentina: 'ARGENTINA',
    armenia: 'ARMENIA',
    aruba: 'ARUBA',
    australia: 'AUSTRALIA',
    austria: 'AUSTRIA',
    azerbaijan: 'AZERBAIJAN',
    bahamas: 'BAHAMAS',
    bahrain: 'BAHRAIN',
    bangladesh: 'BANGLADESH',
    barbados: 'BARBADOS',
    belarus: 'BELARUS',
    belgium: 'BELGIUM',
    belize: 'BELIZE',
    benin: 'BENIN',
    bermuda: 'BERMUDA',
    bhutan: 'BHUTAN',
    bolivia: 'BOLIVIA',
    bosnia: 'BOSNIA',
    botswana: 'BOTSWANA',
    bouvet_island: 'BOUVET ISLAND',
    brazil: 'BRAZIL',
    british_virgin_islands: 'BRITISH VIRGIN ISLANDS',
    brunei: 'BRUNEI',
    bulgaria: 'BULGARIA',
    burkuina_faso: 'BURKINA FASO',
    burundi: 'BURUNDI',
    cambodia: 'CAMBODIA',
    cameroon: 'CAMEROON',
    canada: 'CANADA',
    cape_verde_islands: 'CAPE VERDE ISLANDS',
    cayman_islands: 'CAYMAN ISLANDS',
    chad: 'CHAD',
    chile: 'CHILE',
    china: 'CHINA',
    cocos_islands: 'COCOS (KEELING) ISLAND',
    colombia: 'COLOMBIA',
    comoros: 'COMOROS',
    cook_islands: 'COOK ISLANDS',
    costa_rica: 'COSTA RICA',
    cotedivoire: 'IVORY COAST',
    croatia: 'CROATIA',
    cuba: 'CUBA',
    cyprus: 'CYPRUS',
    czech_republic: 'CZECH REPUBLIC',
    denmark: 'DENMARK',
    democratic_republic_of_congo: 'CONGO KINSHASA',
    djibouti: 'DJIBOUTI',
    dominica: 'DOMINICA',
    dominican_republic: 'DOMINICAN REPUBLIC',
    ecuador: 'ECUADOR',
    egypt: 'EGYPT',
    el_salvador: 'EL SALVADOR',
    equatorial_guinea: 'EQUATORIAL GUINEA',
    estonia: 'ESTONIA',
    ethiopia: 'ETHIOPIA',
    falkland_islands: 'FALKLAND ISLANDS',
    faroe_islands: 'FAEROE ISLANDS',
    fiji: 'FIJI',
    finland: 'FINLAND',
    french_guiana: 'FRENCH GUIANA',
    french_polynesia: 'FRENCH POLYNESIA',
    french_southern_and_antarctic_lands: 'FRENCH SOUTHERN AND ANTARCTIC LANDS',
    gabon: 'GABON',
    gambia: 'GAMBIA',
    georgia: 'GEORGIA',
    ghana: 'GHANA',
    gibraltar: 'GIBRALTAR',
    greece: 'GREECE',
    greenland: 'GREENLAND',
    grenada: 'GRENADA',
    guadeloupe: 'GUADELOUPE',
    guam: 'GUAM',
    guatemala: 'GUATEMALA',
    guinea: 'GUINEA',
    guinea_bissau: 'GUINEA-BISSAU',
    guyana: 'GUYANA',
    haiti: 'HAITI',
    heard_island_and_mcdonald_islands: 'HEARD ISLAND AND MCDONALD ISLANDS',
    honduras: 'HONDURAS',
    hong_kong: 'HONG KONG',
    hungary: 'HUNGARY',
    iceland: 'ICELAND',
    india: 'INDIA',
    indonesia: 'INDONESIA',
    iran: 'IRAN',
    iraq: 'IRAQ',
    ireland: 'IRELAND',
    israel: 'ISRAEL',
    italy: 'ITALY',
    jamaica: 'JAMAICA',
    jan_mayen: 'JAN MAYEN',
    japan: 'JAPAN',
    jersey: 'JERSEY',
    johnston_atoll: 'JOHNSTON ATOLL',
    jordan: 'JORDAN',
    kazakhstan: 'KAZAKHSTAN',
    kenya: 'KENYA',
    kiribati: 'KIRIBATI',
    kosovo: 'KOSOVO',
    kuwait: 'KUWAIT',
    kyrgyzstan: 'KYRGYZSTAN',
    laos: 'LAOS',
    latvia: 'LATVIA',
    lebanon: 'LEBANON',
    lesotho: 'LESOTHO',
    liberia: 'LIBERIA',
    libya: 'LIBYA',
    liechtenstein: 'LIECHTENSTEIN',
    lithuania: 'LITHUANIA',
    luxembourg: 'LUXEMBOURG',
    macau: 'MACAO',
    macedonia: 'MACEDONIA',
    madagascar: 'MADAGASCAR',
    malawi: 'MALAWI',
    malaysia: 'MALAYSIA',
    maldives: 'MALDIVES',
    mali: 'MALI',
    malta: 'MALTA',
    marshall_islands: 'MARSHALL ISLANDS',
    martinique: 'MARTINIQUE',
    mauritania: 'MAURITANIA',
    mauritius: 'MAURITIUS',
    mexico: 'MEXICO',
    micronesia: 'MICRONESIA',
    midway_islands: 'MIDWAY ISLANDS',
    moldova: 'MOLDOVA',
    monaco: 'MONACO',
    mongolia: 'MONGOLIA',
    montenegro: 'MONTENEGRO',
    montserrat: 'MONTSERRAT',
    morocco: 'MOROCCO',
    mozambique: 'MOZAMBIQUE',
    myanmar: 'MYANMAR',
    namibia: 'NAMIBIA',
    nepal: 'NEPAL',
    netherlands: 'NETHERLANDS',
    netherlands_antilles: 'NETHERLANDS ANTILLES',
    new_caledonia: 'NEW CALEDONIA',
    new_zealand: 'NEW ZEALAND',
    nicaragua: 'NICARAGUA',
    niger: 'NIGER',
    nigeria: 'NIGERIA',
    norfolk_island: 'NORFOLK ISLAND',
    north_korea: 'KOREA, NORTH',
    norway: 'NORWAY',
    oman: 'OMAN',
    pacific_ocean: 'PACIFIC ISLAND',
    pakistan: 'PAKISTAN',
    palau: 'PALAU',
    panama: 'PANAMA',
    papa_new_guinea: 'PAPUA NEW GUINEA',
    paraguay: 'PARAGUAY',
    peru: 'PERU',
    philippines: 'PHILIPPINES',
    pitcairn_islands: 'PITCAIRN ISLANDS',
    poland: 'POLAND',
    portugal: 'PORTUGAL',
    puerto_rico: 'PUERTO RICO',
    qatar: 'QATAR',
    reunion: 'REUNION',
    republic_of_the_congo: 'CONGO, REPUBLIC OF THE',
    romania: 'ROMANIA',
    russia: 'RUSSIA',
    rwanda: 'RWANDA',
    saint_helena: 'SAINT HELENA',
    saint_kitts_and_nevis: 'SAINT KITTS AND NEVIS',
    saint_lucia: 'SAINT LUCIA',
    saint_pierre_and_miquelon: 'SAINT PIERRE AND MIQUELON',
    saint_vincent_and_the_grenadines: 'SAINT VINCENT AND THE GRENADINES',
    samoa: 'SAMOA',
    san_marino: 'SAN MARINO',
    sao_tome_and_principe: 'SAO TOME AND PRINCIPE',
    saudi_arabia: 'SAUDI ARABIA',
    senegal: 'SENEGAL',
    serbia: 'SERBIA',
    seychelles: 'SEYCHELLES',
    sierra_leone: 'SIERRA LEONE',
    singapore: 'SINGAPORE',
    slovakia: 'SLOVAKIA',
    slovenia: 'SLOVENIA',
    solomon_islands: 'SOLOMON ISLANDS',
    somalia: 'SOMALIA',
    south_africa: 'SOUTH AFRICA',
    south_korea: 'KOREA, SOUTH',
    spain: 'SPAIN',
    sri_lanka: 'SRI LANKA',
    sudan: 'SUDAN',
    suriname: 'SURINAME',
    svalbard: 'SVALBARD',
    swaziland: 'SWAZILAND',
    sweden: 'SWEDEN',
    syria: 'SYRIA',
    taiwan: 'TAIWAN',
    tajikistan: 'TAJIKISTAN',
    tanzania: 'TANZANIA',
    thailand: 'THAILAND',
    togo: 'TOGO',
    tonga: 'TONGA',
    trinidad: 'TRINIDAD AND TOBAGO',
    tunisia: 'TUNISIA',
    turkey: 'TURKEY',
    turkmenistan: 'TURKMENISTAN',
    turks_and_caicos_islands: 'TURKS AND CAICOS ISLANDS',
    tuvalu: 'TUVALU',
    uganda: 'UGANDA',
    ukraine: 'UKRAINE',
    united_arab_emirates: 'UNITED ARAB EMIRATES',
    uruguay: 'URUGUAY',
    uzbekistan: 'UZBEKISTAN',
    vanuatu: 'VANUATU',
    venezuela: 'VENEZUELA',
    vietnam: 'VIETNAM',
    wake_island: 'WAKE ISLAND',
    wallis_and_futuna: 'WALLIS AND FUTUNA',
    west_bank: 'WEST BANK',
    western_sahara: 'WESTERN SAHARA',
    yemen: 'YEMEN',
    zambia: 'ZAMBIA',
    zimbabwe: 'ZIMBABWE',
    palmyra_atoll: 'palmyra_atoll',
    paracel_islands: 'paracel_islands',
    south_georgia_and_the_south_sandwich_islands:
      'south_georgia_and_the_south_sandwich_islands',
    spratly_islands: 'spratly_islands',
    tokelau: 'tokelau',
    trommelin_island: 'trommelin_island',
    nauru: 'nauru',
    navassa_island: 'navassa_island',
    mayotte: 'mayotte',
    ashmore_and_cartier_islands: 'ashmore_and_cartier_islands',
    atlantic_ocean: 'atlantic_ocean',
    baker_island: 'baker_island',
    bassas_da_india: 'bassas_da_india',
    central_african_republic: 'central_african_republic',
    christmas_island: 'christmas_island',
    clipperton_island: 'clipperton_island',
    coral_sea_islands: 'coral_sea_islands',
    east_timor: 'east_timor',
    eritrea: 'eritrea',
    europaisland: 'europaisland',
    gaza_strip: 'gaza_strip',
    glorioso_islands: 'glorioso_islands',
    guernsey: 'guernsey',
    howland_island: 'howland_island',
    indian_ocean: 'indian_ocean',
    isle_of_man: 'isle_of_man',
    jarvisiland: 'jarvisiland',
    juan_de_nova_island: 'juan_de_nova_island',
    kingman_reef: 'kingman_reef',
    kerguelen_archipelago: 'kerguelen_archipelago',
    niue: 'niue',
    north_sea: 'north_sea',
    northern_mariana_islands: 'northern_mariana_islands',
  },
};

export const applyInboundAdditionalData = (
  action: string,
  inboundData: {
    url: string;
    event: string;
    visitor: string;
    confirmed: boolean;
  }
) => {
  switch (action) {
    case 'agenda-download':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.DOWNLOAD_AGENDA as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    case 'attendeelist-download':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.DOWNLOAD_ATTENDEE_LIST as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    case 'partner-prospectus-download':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.DOWNLOAD_BP_PACKAGES as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    case 'white-paper-download':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.DOWNLOAD_WHITE_PAPER as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    case 'video-content':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.VIDEO_CONTENT as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    case 'podcast-content':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.PODCAST_CONTENT as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    case 'start-survey':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.SURVEY_MONKEY as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    case 'webapp-freeticket-onsite':
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.WEBAPP_FREE_TICKET_ONSITE as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
    default:
      return {
        ...inboundData,
        action: INBOUND_ACTIONS.DOWNLOAD_AGENDA as InboundAction,
        forcemail: true,
        ticketurl: '',
        contact_type: 'del',
        file_link: '',
        customtemplate: '',
      };
  }
};

export const defaultInboundValues = {
  salutation: {
    visible: true,
    required: true,
  },
  first_name: {
    visible: true,
    required: true,
  },
  job_title: {
    visible: true,
    required: true,
  },
  last_name: {
    visible: true,
    required: true,
  },
  email: {
    visible: true,
    required: true,
  },
  company_name: {
    visible: true,
    required: true,
  },
  contact_mobile: {
    visible: true,
    required: true,
  },
  address_country: {
    visible: true,
    required: false,
  },
};

const transformValue = (value: string) => {
  if (value === 'true') return 1;
  if (value === 'false') return 0;
  return value;
};

export const groupByLastCharacter = (obj: Record<string, string>) => {
  const groupKey = (key: string) => {
    const lastChar = key.slice(-1);
    if (/[^\d]/.test(lastChar)) return 'nonNumericEnd';
    if (lastChar === '1') return 'endsWith1';
    if (lastChar === '2') return 'endsWith2';
    if (lastChar === '3') return 'endsWith3';
    if (lastChar === '4') return 'endsWith4';
    if (lastChar === '5') return 'endsWith5';
  };

  const grouped = Object.entries(obj).reduce(
    (acc, [key, value]) => {
      const group = groupKey(key) as
        | 'nonNumericEnd'
        | 'endsWith1'
        | 'endsWith2'
        | 'endsWith3'
        | 'endsWith4'
        | 'endsWith5';
      return {
        ...acc,
        [group]: {
          ...acc[group],
          [key.split('-')?.[0]]: transformValue(value),
        },
      };
    },
    {
      nonNumericEnd: {},
      endsWith1: {},
      endsWith2: {},
      endsWith3: {},
      endsWith4: {},
      endsWith5: {},
    }
  );

  const nonNumericEnd = grouped.nonNumericEnd;
  const combinedArray = Object.entries(grouped)
    .filter(
      ([groupName, groupObj]) =>
        groupName !== 'nonNumericEnd' && Object.keys(groupObj).length > 0
    )
    .map(([_, groupObj]) => groupObj);
  return {
    nonNumericEnd,
    combinedArray,
  };
};
